<template>
  <div id="contenedor-configuracion-firmas-nueva">
     <v-card>
      <v-card-title flat class="secondary--text"> Registrar nueva firma</v-card-title>
      <v-card-text>
        <v-form
          v-model="formularioValido"
          ref="registrarNuevaFirma">
          <auto-complete
            v-model="firma.idFuncionario"
            label="Funcionario"
            :items="getFuncionarios"
            item-text="nombre"
            item-value="id"
            :rules="[mixReglas.requerido]">
          </auto-complete>
          <custom-text-field
            v-model.number="firma.orden"
            type="number"
            label="Orden"
            :rules="[mixReglas.requerido]">
          </custom-text-field>
        </v-form>
      </v-card-text>
       <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="guardar"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Guardar"
        >
        </custom-button>
      </v-card-actions>
     </v-card>
  </div>
</template>

<script>
import AGREGAR_FIRMA from '@/graphql/mutations/administracion/configuracion/firmas/agregarFirma.gql';
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import Funcionarios from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import AutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ConfiguracionFirmasNueva',
  components: {
    AutoComplete,
    CustomTextField,
    CustomButton,
  },
  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      firma: {
        idFuncionario: '',
        modulo: this.modulo,
        orden: 1,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevaFirma.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      const { firma } = this;

      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_FIRMA,
          variables: {
            firma,
          },
          update: (store, { data: { agregarFirma } }) => {
            const query = {
              query: FIRMAS_POR_MODULO,
              variables: {
                modulo: this.modulo,
              },
            };
            const { firmasPorModulo } = store.readQuery(query);
            const firmasPorModuloCopia = firmasPorModulo.slice();
            firmasPorModuloCopia.push(agregarFirma);
            store.writeQuery({
              ...query,
              data: {
                firmasPorModulo: firmasPorModuloCopia,
              },
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
    },
  },
  apollo: {
    funcionarios: {
      query: Funcionarios,
    },
  },
  computed: {
    getFuncionarios() {
      if (!this.funcionarios) return [];
      return this.funcionarios;
    },
  },
};
</script>

<style lang="scss">

</style>
